<template>
  <div class="dialog-wap">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      :before-close="handleClose"
      class="error-dialog"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            延期
          </h4>
        </div>
      </template>
      <el-tag
        class="h-12 justify-start mb-3 w-full text-sm"
      >
        1.延期后，将修改任务的签署截止日期 <br>
        2.单个任务最多可延期3次 (剩余次数:{{ extensionsNum }}次)
      </el-tag>
      <el-form
        ref="formRef"
        class="add-platform-users-form"
        require-asterisk-position="right"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="extensionsDate" label="延期至">
          <el-date-picker
            v-model="form.extensionsDate"
            style="width: 100%;"
            type="date"
            clearable
            placeholder="请选择日期"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            :loading="saveBtnLoading" @click="handleClose"
          >
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">

import { PropType, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { queryContractCreateExtensionsNum, queryContractCreateOperate } from '../../../../..';
import { IContractCreatePage } from '../../../../../types/contracts/contracts';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IContractCreatePage>,
    default: () => {},
  },
});

const emit = defineEmits<{close: []}>();

const disabledDate = (current: Date) => current.getTime() < new Date(props.row.endTime).getTime();

const saveBtnLoading = ref(false);
const formRef = ref();
const extensionsNum = ref(0);

const form = ref({ extensionsDate: '' });

const formRules = ref({
  extensionsDate: [
    {
      required: true,
      message: '请选择延期时间',
    },
  ],
});

function handleClose() {
  formRef.value.resetFields();
  emit('close');
}

function handleSubmit() {

  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

async function doSubmit() {

  saveBtnLoading.value = true;

  try {
    await queryContractCreateOperate({
      contractId: String(props.row.id),
      type: 2,
      extensionsDate: form.value.extensionsDate,
    });
    handleClose();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  saveBtnLoading.value = false;

}

async function fetchData() {
  try {
    extensionsNum.value = await queryContractCreateExtensionsNum(props.row.id);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function init() {
  await fetchData();
}

watch(
  () => [props.visible],
  async () => {
    if (props.visible) {
      init();
    }
  },
);
</script>

<style lang="scss" scoped>
.dialog-wap {
  :deep(.el-dialog__body) {
    padding-bottom: 6px;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
